import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA }
	from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';

@Component({
	selector: 'copo-snackbar-save-draft',
	templateUrl: './snackbar-save-draft.comonent.html',
	styleUrl: './snackbar-save-draft.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [NgIf, TranslateModule]
})
export class SnackbarSaveDraftComponent {
	constructor(
		private readonly snackBarRef: MatSnackBarRef<SnackbarSaveDraftComponent>,
		@Inject(MAT_SNACK_BAR_DATA) public errorOccured: boolean
	) {}

	dismiss() {
		this.snackBarRef.dismiss();
	}
}
